import { isEmpty } from '@sgme/fp';
import { isEqual } from 'lodash-es';

export function addElements<T = string | number | boolean>(array: readonly T[], ...elementsToAdd: T[]): readonly T[] {
  if (isEmpty(elementsToAdd)) {
    return array;
  }
  return [...array, ...elementsToAdd];
}

export function removeElements<T = string | number | boolean | Record<string, unknown>>(
  array: readonly T[],
  ...elementsToRemove: readonly T[]
): readonly T[] {
  if (isEmpty(elementsToRemove)) {
    return array;
  }
  return array.filter(e => !elementsToRemove.some(i => isEqual(i, e)));
}

export function replaceElements<T = string | number | boolean>(
  array: readonly T[],
  elementToReplace: T,
  newElement: T,
): readonly T[] {
  if (!array.includes(elementToReplace)) {
    return array;
  }
  return array.map(e => (e === elementToReplace ? newElement : e));
}

export function splitIntoChunksOf<T = string | number | boolean>(
  array: readonly T[],
  chunkSize: number,
): readonly T[][] {
  const res: T[][] = [];

  if (array.length === 0 || chunkSize < 1) {
    return res;
  }

  for (let i = 0; i < array.length; i += chunkSize) {
    res.push(array.slice(i, i + chunkSize));
  }
  return res;
}
